const { generate: genId } = require("shortid");
const { assignIdsToHeaders } = require("../../utils/prismic-data-utils");

module.exports.transformGetInvolvedPageData = data => {
	return data.prismic.allReapredistGetInvolvedPages.edges.map(({ node }) => ({
		staffContact: node.staffContact.map(contact => ({
			id: genId(),
			...contact,
		})),
		gettingInvolvedBody: assignIdsToHeaders(node.gettingInvolvedBody),
		contactHeading: assignIdsToHeaders(node.contactHeading),
		staffContactHeading: assignIdsToHeaders(node.staffContactHeading),
		contactLinks: node.contactLinks.map(link => ({
			id: genId(),
			url: link.url ? link.url.url : null,
			displayText: link.displayText,
		})),
	}))[0];
};
